var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6395 0.83313L13.1378 1.76461C13.4747 2.39435 13.6432 2.70922 13.5318 2.84407C13.4204 2.97892 13.0536 2.87001 12.3199 2.6522C11.5864 2.43443 10.8076 2.31726 10.0007 2.31726C5.6284 2.31726 2.08398 5.75685 2.08398 9.9998C2.08398 11.3991 2.4695 12.7111 3.14309 13.8411",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.36201 19.1664L6.8637 18.235C6.5268 17.6052 6.35835 17.2903 6.46973 17.1555C6.58112 17.0206 6.94797 17.1296 7.68164 17.3474C8.41514 17.5651 9.19392 17.6823 10.0009 17.6823C14.3732 17.6823 17.9176 14.2427 17.9176 9.99978C17.9176 8.60045 17.532 7.28851 16.8585 6.15851",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.b233e42fa25633b33e2f6983a6ecaa0e.svg";
export { ForwardRef as ReactComponent };